/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from "react";
import { withApollo } from "react-apollo";
import { Col, Form, Row, Table, Modal, Icon } from "antd";
import PropTypes from "prop-types";
import { changeFormatdate } from "../../../../../../utils/formatdate";
import { checkLinkURL } from "../../../../../../utils/auth";

const url = checkLinkURL();

class InEducation extends Component {
  state = {
    columns: [
      {
        title: "ปีการศึกษา",
        dataIndex: "studyLearnYear",
        align: "center",
        width: 150,

        render: (item, record, index) => item || "-",
      },
      {
        title: "ภาคการศึกษาที่",
        dataIndex: "studyLearnTerm",
        align: "center",
        width: 150,
        render: (item, record, index) => item || "-",
      },
      {
        title: "เกรดเฉลี่ย (GPA) / ผลการศึกษา",
        align: "center",
        dataIndex: "studyLearnGrade",
        width: 200,
        render: (item, record, index) => item || "-",
      },
      {
        title: "เกรดเฉลี่ยสะสม (GPAX) / ผลการศึกษา",
        dataIndex: "studyLearnGPAX",
        width: 200,
        align: "center",
        render: (item, record, index) => item || "-",
      },
      {
        title: "เอกสารแนบ",
        dataIndex: "file",
        width: 200,
        align: "center",
        render: (item, record, index) =>
          this.showMoreFileUploadsAttach(record, index),
      },
      {
        title: "หมายเหตุ",
        dataIndex: "studyLearnRemark",
        width: "30%",
        align: "center",
        render: (item, record, index) => item || "-",
      },
      {
        title: "สถานะการตรวจสอบเอกสาร",
        dataIndex: "studyLearnReviewName",
        width: 200,
        align: "center",
        render: (item, record, index) => item || "-",
      },
      {
        title: "วันที่ตรวจสอบเอกสาร",
        dataIndex: "studyLearnReviewAt",
        width: 200,
        align: "center",
        render: (item, record, index) => (item ? changeFormatdate(item) : "-"),
      },
      {
        title: "สาเหตุที่ไม่ผ่านการศึกษา",
        dataIndex: "studyLearnReviewRemark",
        width: 200,
        align: "center",
        render: (item, record, index) => item || "-",
      },
    ],
  };

  showMoreFileUploadsAttach = (data, index) => {
    if (data?.studyfilePath) {
      return (
        <p
          onClick={() => this.modalShowFileCreate(data, index)}
          style={{ cursor: "pointer" }}
          className="mb-0 btn-show-fileuploads"
        >
          ดูไฟล์เอกสารแนบ
        </p>
      );
    }
    return "-";
  };

  modalShowFileCreate = async (data, index) => {
    Modal.info({
      className: "modalFickIcons",
      title: "ไฟล์อัปโหลดเอกสารแนบ",
      width: "1000px",
      content: (
        <div>
          <hr></hr>
          <div className="mt-4">
            <Row gutter={16} type="flex" justify="left" align="top">
              <Col
                span={10}
                className="mb-3 block_show_file"
                style={{ display: "block" }}
              >
                {data.studyFileType !== "application/pdf" ? (
                  <div
                    style={{
                      width: "100%",
                      height: "200px",
                      padding: "10px 55px",
                    }}
                    align="center"
                    className="block-show-image-modal"
                  >
                    <img
                      alt="img"
                      src={url + data.studyfilePath}
                      style={{ height: "100%" }}
                    />
                    <a
                      onClick={() =>
                        this.onClickToNewTab(data.studyFileType, index)
                      }
                      className="icons-show-images"
                    >
                      <Icon type="eye" style={{ color: "#fff" }} />
                    </a>
                  </div>
                ) : (
                  <div
                    style={{ width: "100%", height: "200px" }}
                    align="center"
                    className="block-show-image-modal"
                  >
                    <iframe
                      title="image"
                      style={{ display: "none", opacity: "0", height: "0" }}
                    ></iframe>
                    <a
                      onClick={() =>
                        this.onClickToNewTab(data.studyFileType, index)
                      }
                      className="color-white"
                    >
                      <Icon type="file-pdf" />
                      <br></br>
                      ดูไฟล์ PDF
                    </a>
                    <br></br>
                  </div>
                )}
              </Col>
            </Row>
          </div>
        </div>
      ),
      okText: "ปิด",
      onOk() {},
    });
  };

  onClickToNewTab = (typeFile, index) => {
    const { rawData } = this.props;
    const studyfilePath = rawData?.studyLearnRecords[index]?.studyfilePath;
    if (studyfilePath) {
      const win = window.open();
      const element =
        typeFile !== "application/pdf"
          ? `<div style="margin:0 auto; width:900px; max-width:900px" align="center"><img src="${url}${studyfilePath}" style="height:100%"/></div>`
          : `<iframe src="${url}${studyfilePath}" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>`;

      win.document.write(element);
    }
  };

  render() {
    const { columns } = this.state;
    const { rawData } = this.props;
    const studyLearnRecords = rawData?.studyLearnRecords || [];

    return (
      <Row gutter={16} type="flex" justify="left" align="top">
        <Col xs={24} md={24} className="pt-0">
          <strong className="color-red">ผลการศึกษา</strong>
        </Col>
        <Col xs={24} md={24} align={"right"} className="pt-4">
          <Table
            columns={columns}
            dataSource={studyLearnRecords}
            className="mb-3"
            pagination={false}
            bordered
            locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
            scroll={{ x: "max-content" }}
            rowKey="id"
          />
        </Col>
      </Row>
    );
  }
}

InEducation.defaultProps = {
  autoFocus: false,
};

InEducation.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedInEducation = Form.create()(InEducation);

export default withApollo(WrappedInEducation);
